module.exports = __webpack_public_path__ + "static/txtling1-1024x908-66fe4d44a78b5555e1b7fe79554ef522.png";